import { useStateMachine } from 'little-state-machine';
import React, { useMemo, useState } from 'react'
import { useForm, useFormState } from 'react-hook-form';
import {
  Box,
  Stack,
  Container,
  Heading,
} from "@chakra-ui/react"
import { nanoid } from 'nanoid';
import { httpsCallable } from 'firebase/functions';
import { useSearchParam } from 'react-use';

import updateAction from '../../helpers/updateAction'
import useSlug from '../Layout/useSlug';
import { responsive } from '../../contexts/responsive';
import NavHeading from '../NavHeading'
import VStackWrapper from '../../components/VStackWrapper'
import ContactInfo from './ContactInfo';
import getContactSections from './getContactSections';
import useFunctions from '../../hooks/useFunctions';
import RatioImage from '../RatioImage';
import Button from '../../components/Button';

export { query } from '../portalQuery'

const ContactPage = ({ location, ...data }) => {
  const slug = useSlug()
  const functions = useFunctions();
  const queryKey = useSearchParam('key');

  // const browserName = useMemo(() => {
  //   const parser = new UAParser();
  //   return parser.getBrowser()?.name
  // }, [])
  const { state, actions } = useStateMachine({ updateAction });
  const { control, handleSubmit, register } = useForm({ defaultValues: state?.contact });
  const { isSubmitSuccessful, isSubmitting, errors } = useFormState({ control })

  // const { isValid } = useFormState({ control })
  const fileUploadTask = (file) => new Promise(res => {
    const filename = file.name.replace(/^(.+)\.([^.]+)$/, `${slug}/contact/$1_${nanoid()}.$2`)
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      res({
        filename,
        base64: reader.result,
      })
      //don't do the below. It is pointless. Either assign the result to a variable within scope or call a callback
      //return(reader.result); //THIS NO RETURN NOTHING. WHY?
    };
  })
  const onSubmit = async formData => {
    const submitForm = httpsCallable(functions, 'createContactForm')
    const { type, file, ...rest } = formData
    const sections = getContactSections(data.contact)
    const typeOk = sections.reduce((ok, sec) => {
      let hasSome
      const formatted = {
        title: sec.title,
        steps: sec.steps.map((step, i) => ({
          title: step.title,
          options: step.options.map(label => {
            let active = false
            if (type[sec.title][i] && type[sec.title][i].includes(label)) {
              active = true
              hasSome = true
            }
            return {
              label,
              active,
            }
          })
        }))
      }
      return hasSome ? [...ok, formatted] : ok
    }, [])

    const res = await submitForm({
      name: data.name,
      slug,
      contactForm: {
        type: typeOk,
        file: file?.[0] && file[0] instanceof File && await fileUploadTask(file[0]),
        ...rest
      }
    })
    actions.updateAction({})
    const params = new URLSearchParams(window.location.search);
    params.set('key', res.data)
    window.history.pushState(null, null, `${location.pathname}?${params}`)
  };

  return (
    <Container py={responsive(4, 8)} minHeight="100%" as={Stack}>
      <Stack
        width="full"
        alignItems="stretch"
        bg="white"
        p="2"
        flex="1"
        borderRadius="sm"
        boxShadow="sm"
      >
        {isSubmitSuccessful || queryKey ? (
          <VStackWrapper textAlign="center" justifyContent="center">
            {data.contact?.thanksImage && (
              <Box px={responsive(2, 4)}>
                <RatioImage
                  width="100%"
                  ratio={2}
                  src={data.contact.thanksImage}
                  alt={data.contact?.thanksImage.alt ?? '靜候回覆'}
                  overflow="hidden"
                  rounded="md"
                />
              </Box>
            )}
            <Heading fontSize="large">{data.contact.thanksMessage ?? '確認收到你的詢問了！'}</Heading>
            <Box p="2" pt="8">
              <Button colorScheme="primary" to={`/${slug}`} px="8">返回</Button>
            </Box>
          </VStackWrapper>
        ) : (
          <>
            <NavHeading data={data} backUrl={`/${slug}/contact`} />
            <VStackWrapper
              as="form"
              onSubmit={handleSubmit(onSubmit)}
            >
              <Box flex={1}>
                <ContactInfo register={register} control={control} errors={errors} />
              </Box>
              <Box p="2">
                <Button colorScheme="primary" isFullWidth type="submit" isLoading={isSubmitting}>送出</Button>
              </Box>
            </VStackWrapper>
          </>
        )}
      </Stack>
    </Container>
  )
}

export default ContactPage
